const removeLeadingSlash = (string: string | undefined) => string && string.replace(/^\//, '')

export type ApiParams = {
  version?: string
  type?: string
}

// как только выпилим ЛК1, экспорт нужно от сюда убрать
// экспортироваться должна функция с конкретным апи, а не вайлдкард
// и удалить проксю в кабинет такси docker/etc/nginx/locations/proxy/api.conf + тестинг
export const apiURL = (url: string, {version = '1.0', type = 'api'}: ApiParams = {}) =>
  '/' + [type, version, removeLeadingSlash(url)].filter(Boolean).join('/')

export const cargoApiURL = (url: string) => apiURL(url, {type: 'api/b2b', version: ''})

export const externalApiURL = (url: string) => apiURL(url, {type: 'api/b2b', version: 'external'})
